import { memo, useEffect, useMemo } from "react";
import { Grid, Dropdown } from "semantic-ui-react";
import { useLocation } from "react-router-dom";

import logo from "../../assets/images/logo.png";
import MenuIcon from "../../assets/images/menuView.png";
import { SearchValue } from "../SearchValue/SearchValue";

import "./Header.scss";
import { COMPANY_LOGO } from "../../config/constants";
import { hideSearchPath } from "../../utils/utils";
import { DropDown } from "../selectDropDown/DropDown";

export const HeaderMobileView = memo(
  ({
    options,
    userImage,
    navigate,
    modalStatue,
    company,
    getSearchValue,
    loadCompanyData,
    loadCompanyToken,
    searchCompany,
  }: any) => {
    const pathname = window.location.pathname;
    const companyId = useMemo(() => localStorage.getItem("companyId"), [searchCompany])

    return (
      <div className="mainContentMobile">
        <Grid className="mainContentMobileView">
          <Grid.Column
            mobile={16}
            tablet={8}
            only="tablet mobile"
            className="rightContent mt-1"
            onClick={() => navigate("/")}
          >
            <img src={COMPANY_LOGO} alt="logo" className="logo" />
          </Grid.Column>
          <Grid.Column
            mobile={16}
            tablet={8}
            only="tablet mobile"
            textAlign="right"
            className="removePadding mt-2"
          >
            {hideSearchPath(pathname) ? (
              <div className="searchDiv">
                <DropDown
                  placeholder="Select Company"
                  currentData={company}
                  defaultValue={companyId}
                  handleChangeState={(e, data) => {
                    const companyDetails = company?.find(
                      (companyData: any) => companyData.key === data.value
                    )?.other;
                    getSearchValue(companyDetails)
                  }}
                  onSearchChange={(e, data) => {
                    searchCompany(data.searchQuery)
                  }}
                  loading={loadCompanyData}
                  search
                  customGridColumn="pb-0"
                />
              </div>
            ) : null}
            <div className="userDiv">
              <Dropdown
                trigger={userImage}
                options={options}
                pointing="top left"
                icon={null}
              />
            </div>
            <div onClick={() => modalStatue()}>
              <img src={MenuIcon} alt="logo" className="logoMenu" />
            </div>
          </Grid.Column>
        </Grid>
      </div>
    );
  }
);
